import React, { useState } from "react";
import { string, bool, any } from "prop-types";
import { Link } from "@quintype/components";
import { getTemplateName } from "../../utils";
import { SvgIconHandler } from "../SvgIconHandler";
import { getCategoryAndSubCategory } from "../../../ga-utils";

import "./HeaderMenuItem.m.css";

const HeaderMenuItem = ({ menuItemvalue, isIconNeeded, href, children, customStyleName, pageType, config, story }) => {
  const [isActive, setIsActive] = useState(false);
  let timeout;

  const handleMouseEnter = () => {
    clearTimeout(timeout);
    setIsActive(true);
  };

  const handleMouseLeave = () => {
    timeout = setTimeout(() => {
      setIsActive(false);
    }, 150);
  };

  const trackMenuItemClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let categoryInfo = getCategoryAndSubCategory(window.location, pageType, config, story);
    const templateName =
      pageType === "story-page" ? getTemplateName(story?.["story-template"]) : getTemplateName(pageType);

    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "dl_menu_click",
        link_url: href || "",
        link_text: menuItemvalue,
        link_category: menuItemvalue?.toLowerCase(),
        category: categoryInfo?.category,
        sub_category: categoryInfo?.subCategory,
        content_id: categoryInfo?.contentId,
        template_name: templateName,
        platform: window.innerWidth >= 768 ? "desktop" : "mobile",
        eventCallback: function () {
          if (href) {
            window.location.href = href;
          }
        },
      });
    }
  };

  const ariaLabel = href ? `Go to ${menuItemvalue}` : `Open submenu of ${menuItemvalue}`;
  const tabIndex = !href ? "0" : undefined;
  const menuContent = href ? (
    <div onClick={trackMenuItemClick} style={{ display: "contents" }}>
      <Link href={href} className={isIconNeeded ? 'arrrowlink link' : 'link'} disableAjaxLinks={true}>
        {menuItemvalue}
        {/* {isIconNeeded && <SvgIconHandler type="arrow" width="16" height="16" viewBox="0 0 16 16" />} */}
      </Link>
    </div>
  ) : (
    <span styleName="item" onClick={trackMenuItemClick} className={isIconNeeded ? 'arrrowlink' : ''}>
      {menuItemvalue}
      {/* {isIconNeeded && <SvgIconHandler type="arrow" width="16" height="16" viewBox="0 0 16 16" />} */}
    </span>
  );

  return (
    <li
      className="menu-item"
      styleName={`menu-item ${customStyleName}`}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {menuContent}
      {children && React.cloneElement(children, { isActive })}
    </li>
  );
};

HeaderMenuItem.defaultProps = {
  menuItemvalue: "Rankings",
  isIconNeeded: true,
  href: "",
  children: "",
  customStyleName: "",
  parentMenuName: "",
};

HeaderMenuItem.propTypes = {
  menuItemvalue: string,
  isIconNeeded: bool,
  href: string,
  children: any,
  customStyleName: string,
  parentMenuName: string,
  pageType: string,
};

export default HeaderMenuItem;
